import React, { useState } from 'react';
import { InformationCircleIcon, ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/outline';

const SankeyExplainer = ({ flow, kpis }) => {
  const [open, setOpen] = useState(false);

  const income = flow?.income_monthly ?? 0;
  const hasFlow = income > 0 || (flow?.links?.length ?? 0) > 0;

  return (
    <div className="mb-4 border border-hairline rounded-lg bg-bone-raised">
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between gap-2 px-4 py-3 text-left"
      >
        <span className="flex items-center gap-2 text-body text-ink">
          <InformationCircleIcon className="w-5 h-5 text-ink-muted shrink-0" />
          How to read this money flow chart
        </span>
        {open ? (
          <ChevronUpIcon className="w-4 h-4 text-ink-muted" />
        ) : (
          <ChevronDownIcon className="w-4 h-4 text-ink-muted" />
        )}
      </button>
      {open && (
        <div className="px-4 pb-4 text-body text-ink-muted space-y-2 border-t border-hairline pt-3">
          <p>
            This <strong className="text-ink font-medium">Sankey diagram</strong> shows where your monthly income
            goes. <strong className="text-ink font-medium">Nodes</strong> are steps (income, essentials, lifestyle, outcomes);{' '}
            <strong className="text-ink font-medium">flows</strong> are dollar amounts between them. Wider bands mean more money.
          </p>
          <ul className="list-disc list-inside space-y-1">
            <li>
              <span className="text-ink">Income</span> splits into essentials, lifestyle, and what is left to save or invest.
            </li>
            <li>
              <span className="text-ink">Essentials</span> are must-pay bills you have tagged.
            </li>
            <li>
              <span className="text-ink">Lifestyle</span> is discretionary spending you could redirect toward a vision.
            </li>
            <li>
              <span className="text-ink">Investable</span> is surplus after essentials and lifestyle
              {kpis?.investable_surplus != null && (
                <> (about <span className="figure text-ink">${Number(kpis.investable_surplus).toLocaleString()}</span>/mo)</>
              )}
              .
            </li>
          </ul>
          {!hasFlow && (
            <p className="text-label text-warning">
              Add income and expenses in Add / edit expenses to see a full flow.
            </p>
          )}
          <p className="text-label text-ink-faint">Hover any band for the exact dollar amount.</p>
        </div>
      )}
    </div>
  );
};

export default SankeyExplainer;
